import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import PlayersAPI from "../api/players";
import FreezeAssers from "../api/freeze_assets";
import { useSelector } from "react-redux";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Tooltip } from "@mui/material";
import DatePicker from "react-datepicker";
import CustomDate from "./sub_components/date";
import "react-datepicker/dist/react-datepicker.css";

const Users = () => {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.auth.currentUser);
  useEffect(() => {
    if (currentUser === null) {
      return navigate("/signin");
    }
  }, []);
  const [dataToShow, setDataToShow] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [tempPage, setTempPage] = useState(pageNumber);
  const [filterId, setFilterId] = useState("");
  const [idPredicate, setIdPredicate] = useState("eq");

  const [filterName, setFilterName] = useState("");
  const [namePredicate, setNamePredicate] = useState("contains");

  const [filterEmail, setFilterEmail] = useState("");
  const [emailPredicate, setEmailPredicate] = useState("contains");

  const [freezeTriggered, setFreezeTriggered] = useState(false);
  const [filter, setFilter] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [totalData, setTotalData] = useState("");

  useEffect(() => {
    filter && setPageNumber(1);
    setDataLoading(true);
    PlayersAPI.getPlayers(
      pageNumber,
      filter,
      filterId,
      filterName,
      idPredicate,
      namePredicate,
      filterEmail,
      emailPredicate,
      startDate,
      endDate
    )
      .then((response) => {
        setDataLoading(false);
        setDataToShow(response.data.list);
        setTotalPages(response.data.total_pages);
        setTotalData(response.data.total_count);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [
    pageNumber,
    filter,
    filter && freezeTriggered,
    filter && filterId,
    filter && filterName,
    filter && filterEmail,
    filter && idPredicate,
    filter && namePredicate,
    filter && emailPredicate,
    filter && startDate,
    filter && endDate,
  ]);
  const increasePage = () => {
    if (tempPage < totalPages) {
      setPageNumber(parseFloat(pageNumber) + 1);
      setTempPage(pageNumber);
      setTempPage(parseFloat(tempPage) + 1);
    }
  };

  const decrPage = () => {
    if (tempPage > 1) {
      setPageNumber(parseFloat(pageNumber) - 1);
      setTempPage(pageNumber);
      setTempPage(parseFloat(tempPage) - 1);
    }
  };
  const handleChange = (event) => {
    setTempPage(event.target.value);
  };

  const assignPage = (e) => {
    if (e.key === "Enter") {
      setPageNumber(e.target.value);
    }
  };

  return (
    <div className="content">
      <div className="container-fluid pt-4 pb-4 px-4">
        <div className="page-title">
          <h1>Players</h1>
        </div>
        <div className="page-filters">
          <div className="row">
            <div className="col-lg-6 col-xl-3">
              <label htmlFor="basic-url" className="form-label">
                User Id
              </label>
              <div className="input-group mb-3">
                <select
                  className="input-group-text"
                  id="basic-addon3"
                  value={idPredicate}
                  onChange={(e) => {
                    setIdPredicate(e.target.value);
                  }}
                >
                  <option value="eq">=</option>
                  <option value="gteq">Greater & =</option>
                  <option value="lteq">Less & =</option>
                </select>
                <input
                  type="text"
                  className="form-control white"
                  id="basic-url"
                  aria-describedby="basic-addon3"
                  value={filterId}
                  onChange={(e) => {
                    setFilterId(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6 col-xl-3">
              <label htmlFor="basic-url" className="form-label">
                User Name
              </label>
              <div className="input-group mb-3">
                <select
                  className="input-group-text"
                  id="basic-addon3"
                  value={namePredicate}
                  onChange={(e) => {
                    setNamePredicate(e.target.value);
                  }}
                >
                  <option value="contains">Contains</option>
                  <option value="eq">Equals To</option>
                </select>
                <input
                  type="text"
                  className="form-control white"
                  id="basic-url"
                  aria-describedby="basic-addon3"
                  value={filterName}
                  onChange={(e) => {
                    setFilterName(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6 col-xl-3">
              <label htmlFor="basic-url" className="form-label">
                Created At
              </label>
              <div className="input-group mb-3">
                {" "}
                <DatePicker
                  placeholderText="From"
                  selected={startDate}
                  placeholder="from"
                  onChange={(date) => setStartDate(date ? date : "")}
                />
              </div>
            </div>
            <div className="col-lg-6 col-xl-3">
              <label htmlFor="" className="form-label">
                &nbsp;
              </label>
              <div className="input-group mb-3">
                {" "}
                <DatePicker
                  placeholderText="To"
                  selected={endDate}
                  onChange={(date) => setEndDate(date ? date : "")}
                />
              </div>
            </div>
            <div className="col-lg-6 col-xl-3">
              <label htmlFor="basic-url" className="form-label">
                User Email
              </label>
              <div className="input-group mb-3">
                <select
                  className="input-group-text"
                  id="basic-addon3"
                  value={emailPredicate}
                  onChange={(e) => {
                    setEmailPredicate(e.target.value);
                  }}
                >
                  <option value="contains">Contains</option>
                  <option value="eq">Equals To</option>
                </select>
                <input
                  type="text"
                  className="form-control white"
                  id="basic-url"
                  aria-describedby="basic-addon3"
                  value={filterEmail}
                  onChange={(e) => {
                    setFilterEmail(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6 col-xl-9">
              <label htmlFor="" className="form-label">
                &nbsp;
              </label>
              <div>
                <Tooltip
                  title={filter ? "Filter Enabled" : "Filter Disabled"}
                  placement="bottom"
                  arrow
                >
                  <button
                    className={`${filter ? "primary-btn-success" : "primary-btn-disable"} relative me-3 mb-3 primary-btn`}
                    style={{
                      padding: "8px 11px 7px",
                    }}
                    type="button"
                    onClick={() => {
                      filter ? setFilter(false) : setFilter(true);
                    }}
                  >
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        background: filter ? "rgb(59 193 23)" : "rgb(237, 99, 0)",
                        borderRadius: "50%",
                        right: "-3px",
                        top: "-3px",
                      }}
                      className="filter-status-indicator absolute"
                    ></div>
                    {filter ? "Active" : "Inactive"}
                  </button>
                </Tooltip>
                Total Players {totalData}
                </div>
            </div>
          </div>
          {/*<div className="text-end">*/}
            {/* <button
              type="button"
              className="btn btn-secondary rounded-pill m-2 reset-filters"
            >
              Reset Filters
            </button> */}
          {/*</div>*/}
        </div>
        <div className="text-center rounded p-4 table-bg">
          <div className="table-responsive">
            <table className="table text-start align-middle table-bordered table-hover mb-0 text-center table-style table-bet-rounds">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Email</th>
                  <th scope="col">Username</th>
                  <th scope="col">Last Seen At</th>
                  <th scope="col">Created At</th>
                  <th scope="col">Action</th>
                  <th scope="col">Assets</th>
                </tr>
              </thead>
              <tbody>
                {dataLoading ? (
                  <tr>
                    <td colspan="7">
                      <div className="loader-container">
                        <div className="lds-ring">
                          <div></div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  dataToShow.map((obj) => {
                    return (
                      <tr>
                        <td>{obj.id}</td>
                        <td>{obj.email}</td>
                        <td>{obj.username}</td>
                        <td>
                          <CustomDate date={obj.last_seen_at} />
                        </td>
                        <td>
                          <CustomDate date={obj.created_at} />
                        </td>
                        <td>
                          <Link
                            to={`/player-details/${obj.id}`}
                            className="view primary-btn"
                          >
                            View
                          </Link>
                        </td>
                        <td>{obj.freeze_assets ? "Freezed" : "Unfreezed"}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
            <div className="pagination-buttons-container width my_row end">
              <div className="next-pre-btn my_row align_center space-between width-15">
                <div className="pre-btn">
                  <button
                    style={{
                      background: "transparent",
                      border: "none",
                    }}
                    className="white"
                    onClick={decrPage}
                  >
                    <ArrowBackIosNewIcon />
                  </button>
                </div>
                <span className="white">
                  <input
                    type="number"
                    value={tempPage}
                    style={{
                      maxWidth: "45px",
                      heigh: "10px",
                      background: "transparent",
                      border: "none",
                      color: "white",
                      textAlign: "center",
                    }}
                    onChange={handleChange}
                    onKeyPress={assignPage}
                  />
                  / {totalPages}
                </span>
                <div className="next-btn">
                  <button
                    className="white"
                    style={{
                      background: "transparent",
                      border: "none",
                    }}
                    onClick={increasePage}
                  >
                    <ArrowForwardIosIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  // );
};

export default Users;
